module.exports = __webpack_public_path__ + "img/lady1.e15f35f9.png";